import * as React from 'react';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Link from '@mui/material/Link';
import Box from '@mui/material/Box';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { login } from './shared/api/user';
import { useNavigate } from "react-router-dom";
import CustomizedSnackbars from './Components/Snackbar';
import { useState } from 'react';
import { inputLabelClasses } from "@mui/material/InputLabel";

function Copyright(props) {
  return (
    <Typography variant="body2" color="text.secondary" align="center" {...props}>
      {'Copyright © '}
      <Link color="inherit" href="https://forunpoint.com.pk/">
        ForunPoint
      </Link>{' '}
      {new Date().getFullYear()}
      {' | Version 2025.1.0.9'}
    </Typography>
  );
}
const theme = createTheme();

export default function SignIn() {
  const [error, setError] = useState("");
  const navigate = useNavigate();
  const style = {
    "& .MuiOutlinedInput-root": {
      "&.Mui-focused fieldset": {
        borderColor: "#CB2704"
      }
    }
  }

  const handleSubmit = async (event) => {
    event.preventDefault();
    const data = new FormData(event.currentTarget);
    let body = {
      email: data.get('email'),
      password: data.get('password'),
    }
    try {
      let res = await login(body);
      if (res.data.user.role === 'ADMIN') {
        localStorage.setItem('token', `bearer ${res.data.token}`);
        navigate("/dashboard");
      } else {
        setError('Not an admin!');
        setTimeout(() => {
          setError('');
        }, 4000);

      }
    } catch (err) {
      setError(err.response.data.status.message);
      setTimeout(() => {
        setError('');
      }, 4000);
    }
  };

  return (
    <ThemeProvider theme={theme}>
      {error && <CustomizedSnackbars msg={error} isOpen={error !== ""}></CustomizedSnackbars>}
      <Container component="main" maxWidth="xs">
        <CssBaseline />
        <Box
          sx={{
            marginTop: 8,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          {/* <Avatar sx={{ m: 1, bgcolor: 'secondary.main' }}>
            <LockOutlinedIcon />
          </Avatar> */}
          <img src="../images/fp2.png" alt="ForunPoint" height={60} />
          <Typography color='#00000' sx={{ mt: 5 }} component="h1" variant="h4">
            Sign In
          </Typography>
          <Box component="form" onSubmit={handleSubmit} noValidate sx={{ mt: 1 }}>
            <TextField
              sx={style}
              InputLabelProps={{
                sx: {
                  [`&.${inputLabelClasses.shrink}`]: {
                    color: "#CB2704"
                  }
                }
              }}
              margin="normal"
              required
              fullWidth
              id="email"
              label="Email Address"
              name="email"
              autoComplete="email"
              autoFocus
            />
            <TextField
              sx={style}
              InputLabelProps={{
                sx: {
                  [`&.${inputLabelClasses.shrink}`]: {
                    color: "#CB2704"
                  }
                }
              }}
              margin="normal"
              required
              fullWidth
              name="password"
              label="Password"
              type="password"
              id="password"
              autoComplete="current-password"
            />
            <FormControlLabel
              control={<Checkbox value="remember" color="primary" />}
              label="Remember me"
            />
            <Typography sx={{ fontWeight: '600' }} variant="body2" color="text.secondary">
              {`Forgot your password? `}
              <Link color="inherit" href="/forgot">
                Reset
              </Link>
            </Typography>
            <Button
              type="submit"
              fullWidth
              variant="contained"
              sx={{ mt: 3, mb: 2, background: '#CB2704', "&:hover": { background: "red" } }}
            >
              Sign In
            </Button>
          </Box>
        </Box>
        <Copyright sx={{ mt: 8, mb: 4 }} />
      </Container>
    </ThemeProvider>
  );
}
